import React from "react";
import { Countdown } from "./Countdown";
import { PricingCards } from "./PricingCards";
import type { PlanId } from "../types/pricing";
type FinalOfferProps = {
  time: {
    hours: number;
    minutes: number;
    seconds: number;
  };
  plan: PlanId;
  onPlanChange: (plan: PlanId) => void;
};
export function FinalOffer({
  time,
  plan,
  onPlanChange
}: FinalOfferProps) {
  return <section id="oferta-final" className="bg-forest" data-id="element-104" data-mp="1ch6bprl0bn30">
      <div className="mx-auto max-w-5xl px-5 py-8 md:px-8 md:py-16" data-id="element-105" data-mp="1qda4dgg8fndd">
        <div className="text-center text-paper" data-id="element-106" data-mp="1lg08bhyc8dgk">
          <h2 className="font-display text-[26px] leading-tight md:text-4xl" data-id="element-107" data-mp="1lf8cq74qqfqa">No dejes pasar esta oportunidad</h2>
          <p className="mt-1 text-sm text-paper/70" data-id="element-108" data-mp="2067gn4umsg3j">Termina en</p>
          <div className="mt-3 md:mt-4" data-id="element-109" data-mp="1v6mk112xojtz">
            <Countdown {...time} data-id="element-110" data-mp="2952m2epupm5s" />
          </div>
        </div>
        <div className="mx-auto mt-5 max-w-2xl rounded-3xl bg-cream p-3 md:mt-8 md:p-6" data-id="element-111" data-mp="295m3lubla8ja">
          <PricingCards name="plan-final" plan={plan} onPlanChange={onPlanChange} premiumNote="La opción más elegida por anfitrionas que quieren protagonizar cada festejo" data-id="element-112" data-mp="247atdihdtw0j" />
        </div>
      </div>
    </section>;
}